module.exports = require('../build/DayPickerInput');



//////////////////
// WEBPACK FOOTER
// ./~/react-day-picker/DayPickerInput/index.js
// module id = 506
// module chunks = 0